import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { authSelector } from "reduxStore/auth/auth.selectors";
import authTypes from "reduxStore/auth/auth.types";
import AuthenticationService from "services/AuthService/Authentication";
import moment from "moment-timezone";
import { FULL_DATE_FORMAT } from "Consts";
import { isNullOrUndefined } from "utils";

const useAuthUser = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { currentUser, isLoggedIn } = useSelector(authSelector);
  const [attemptedFetch, setAttemptedFetch] = useState(false);

  const getUser = useCallback(async () => {
    try {
      const result = await AuthenticationService.authorizeUser();

      if (result && result.data && result.data.userInfo) {
        dispatch({
          type: authTypes.AUTH_SUCCESS,
          payload: {
            allowedClients: result.data.allowedClients,
            currentUser: {
              ...result.data.userInfo,
              lastLoginUtc: moment.utc().format(),
              isSubscriptionExpired: result.data.isSubscriptionExpired,
              subscriptionExpirationUtc: result.data.subscriptionExpirationUtc,
              timezone: moment.tz.guess(),
            },
          },
        });
      } else {
        dispatch({ type: authTypes.LOGOUT });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      dispatch({ type: authTypes.LOGOUT });
    } finally {
      setAttemptedFetch(true);
    }
  }, [dispatch]);

  useEffect(() => {
    if (isLoggedIn) {
      setAttemptedFetch(true);
    } else if (!attemptedFetch) {
      getUser();
    }
  }, [isLoggedIn, attemptedFetch, getUser]);

  if (
    !isLoggedIn &&
    (location?.search?.includes("alertId") || location?.search?.includes("share"))
  ) {
    const redirectPath = `${location.pathname}${location.search}`;

    localStorage.setItem(
      `_shared_redirect`,
      JSON.stringify({ path: redirectPath, time: moment().format(FULL_DATE_FORMAT) })
    );
  }

  if (isLoggedIn) {
    const _shared_redirect: any = localStorage.getItem(`_shared_redirect`);
    if (!isNullOrUndefined(_shared_redirect)) {
      const _redirect = JSON.parse(_shared_redirect);

      const _time_now = moment();
      const _time_then = moment(_redirect.time);
      const _diff_minutes = _time_now.diff(_time_then, "minutes");

      if (_diff_minutes > 2) {
        localStorage.removeItem(`_shared_redirect`);
      }
    }
  }

  return {
    currentUser,
    isLoggedIn,
    attemptedFetch,
  };
};

export default useAuthUser;
